<template>
  <router-view />
  <SiteLoadingScreen v-if="envStore.loading" />
</template>

<script setup lang="ts">
import SiteLoadingScreen from '@/components/SiteLoadingScreen.vue';
import useEnvStore from '@/store/modules/env';

const envStore = useEnvStore();
</script>
